import { ChallengeQuestion, LoginResultDto } from "@/lib/DTMWebAPIClient.generated";
import { RootState } from "@/store/dtm";
import { credentialType } from "@/types/credentialType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface twoFactorAuthState {
    authTwoFa: LoginResultDto
}

const initialState: twoFactorAuthState = {
    authTwoFa: new LoginResultDto({
        challenge2FA: undefined,
        challengeQuestion: new ChallengeQuestion({
            question: ""
        }),
        sessionId: ""
    })
}


export const twoFactorAuthSlice = createSlice({
    name: "twoFactorAuth",
    initialState,
    reducers: {
        setChallenge2FA: (state, action: PayloadAction<any>) => {
            const challenge2FA = action.payload;
            state.authTwoFa.challenge2FA = challenge2FA;
        },
        setChallengeQuestion: (state, action: PayloadAction<ChallengeQuestion | undefined>) => {
            const question = action.payload;
            state.authTwoFa.challengeQuestion = question;
        },
        setSessionId: (state, action: PayloadAction<string | undefined>) => {
            state.authTwoFa.sessionId = action.payload;
        },
        clearTwoFactorState: (state) => {
            state.authTwoFa.challenge2FA = undefined;
            state.authTwoFa.challengeQuestion = undefined;
            state.authTwoFa.sessionId = "";
        }
    }
});

export const { setChallenge2FA, setChallengeQuestion, setSessionId, clearTwoFactorState } = twoFactorAuthSlice.actions

export const selectTwoFactorAuth = (state: RootState) => state.twoFactorAuth;

export default twoFactorAuthSlice.reducer